import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';

interface DateTimelineProps {
  days: string[];
  available: Set<string>;
  selected: string;
  today: string;
  onSelect: (day: string) => void;
}

const DateTimeline: React.FC<DateTimelineProps> = ({ days, available, selected, today, onSelect }) => {
  const { t, language } = useTranslation();
  const locale = language === 'pl' ? 'pl-PL' : 'en-US';

  return (
    <div className="date-timeline" role="tablist">
      {days.map((day) => {
        const date = new Date(`${day}T12:00:00`);
        const enabled = available.has(day);
        const active = day === selected;
        return (
          <button
            key={day}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={!enabled}
            className={`date-timeline__day${active ? ' date-timeline__day--active' : ''}`}
            onClick={() => onSelect(day)}
          >
            <span className="date-timeline__weekday">
              {day === today ? t.philipSnat.today : date.toLocaleDateString(locale, { weekday: 'short' })}
            </span>
            <span className="date-timeline__date">{date.getDate()}</span>
            <span className="date-timeline__month">{date.toLocaleDateString(locale, { month: 'short' })}</span>
          </button>
        );
      })}
    </div>
  );
};

export default DateTimeline;
